import { defineStore } from "pinia";

export const userInfoStore = defineStore("userInfo", {
  state: () => ({
    payload: null, // Store payload
  }),
  actions: {
    setPayload(data) {
      this.payload = data;
    },
    getPayload() {
      return this.payload;
    },
  },
});
